import { getTranslateNsT } from "@/utils/getTranslateNsT";
import { dateFormater } from "project-config/utils/format-time";
import { ColumnsType } from "antd/es/table";
import { translatePayMethod } from "@/utils/translate-fields";
import { dateFormatter } from "project-config/utils/date-formatter";

const t = getTranslateNsT("center");

const columns: ColumnsType<any> = [
  {
    dataIndex: "feeTime",
    title: t("consumption_time_selector"),
    render: (feeTime) => dateFormater(feeTime),
  },
  {
    dataIndex: "feeType",
    title: t("consumption_label_fee_type"),
    render: () => t("consumption_fee_type_3"),
  },
  {
    dataIndex: "payRecordId",
    title: t("consumption_pay_record_id"),
  },
  {
    dataIndex: "userName",
    title: t("user_operate_record_user_name_alias"),
  },
  {
    dataIndex: "accountType",
    title: t("bill_account_type"),
    render: (accountType) => t(`consumption_account_type_${accountType}`),
  },
  {
    dataIndex: "company",
    title: t("user_binfo_perfect_item_company_name"),
  },
  {
    dataIndex: "payMethod",
    title: t("add_invoice_pay_method"),
    render: (row) => translatePayMethod(row),
  },
  {
    dataIndex: "type",
    title: t("member_header_member_type"),
    render: (type) => t(`consumption_picture_vip_type_${type}`),
  },
  {
    dataIndex: "confirmTime",
    title: t("consumption_recharge_time"),
    render: (v) => dateFormatter(v),
  },
  {
    dataIndex: "endTime",
    title: t("consumption_vip_end_time"),
    render: (v) => dateFormatter(v),
  },
  {
    dataIndex: "currency",
    title: t("consumption_currency"),
    render: () => "RMB",
  },
  {
    dataIndex: "cashAmount",
    title: t("consumption_cash_amount"),
  },
];

export function useColumns() {
  return { columns };
}
